import { DialogContent as NovaBaseDialogContent, DialogContentProps } from '@fme-nova/components'
import { DialogContent as MuiBaseDialogContent, styled } from '@mui/material'

import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'

const MuiDialogContent = styled(MuiBaseDialogContent)<DialogContentProps>`
  padding: 0;
  border-bottom: 1px solid ${COLORS.divider};
  display: flex;
  flex-direction: column;
`

export const DialogContent = createComponentWrapperWithRef<DialogContentProps>(
  {
    mui: MuiDialogContent,
    nova: NovaBaseDialogContent,
  },
  'DialogContent',
)
